import { useState, useEffect } from 'react';
import { EventoBoleteraModel } from '../models/EventoBoleteraModel';
import { NivelesResumen } from '../models/NivelEntradaModel';
import { SubSeccionesResumen } from '../models/SubSeccionModel';
import { obtenerEventosBoletera, obtenerEventoBoleteraPorId, obtenerNiveles, obtenerSubsecciones } from '../../../../service/boletera/EventosBoletera';

export function useObtenerEventosBoletera(reload: number) {
  const [list, setList] = useState<EventoBoleteraModel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    obtenerEventosBoletera()
      .then(setList)
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [reload]);

  return { list, loading };
}

export function useObtenerEventoBoletera(id: number, reload: number) {
  const [evento, setEvento] = useState<EventoBoleteraModel | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    obtenerEventoBoleteraPorId(id)
      .then(setEvento)
      .catch(() => setEvento(null))
      .finally(() => setLoading(false));
  }, [id, reload]);

  return { evento, loading };
}

export function useObtenerNiveles(eventoId: number, reload: number) {
  const [resumen, setResumen] = useState<NivelesResumen>({
    rows: [],
    count: 0,
    aforo_max_evento: 0,
    aforo_max_recinto: 0,
    asignado: 0,
    disponible: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!eventoId) return;
    setLoading(true);
    obtenerNiveles(eventoId)
      .then(setResumen)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [eventoId, reload]);

  return { resumen, loading };
}

export function useObtenerSubsecciones(nivelId: number | null | undefined, reload: number) {
  const [resumen, setResumen] = useState<SubSeccionesResumen>({
    rows: [],
    nivel_cantidad_boletos: 0,
    asignado: 0,
    disponible: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!nivelId) return;
    setLoading(true);
    obtenerSubsecciones(nivelId)
      .then(setResumen)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [nivelId, reload]);

  return { resumen, loading };
}
